import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { KioskPermissionsService } from '../services/kiosk-permissions.service';
import { KioskPermissionsInt } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class KioskPermissionGuard implements CanActivate {

  constructor(
    private permissionsService: KioskPermissionsService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    const requiredPermission = route.data['permission'] as keyof KioskPermissionsInt;
    
    if (!requiredPermission) {
      console.warn('[KioskPermissionGuard] ⚠️ No se especificó permiso en route data');
      return true;
    }

    const hasPermission = this.permissionsService.hasPermission(requiredPermission);
    
    if (!hasPermission) {
      console.warn(
        `[KioskPermissionGuard] ⛔ Acceso denegado a ${state.url} - Permiso requerido: ${requiredPermission}`
      );
      // Redirigir al home o menú principal
      return this.router.createUrlTree(['/home']);
    }

    return true;
  }
}
